import React from 'react';
import styles from './AnimatedGradientBorder.module.css';

export interface AnimatedGradientBorderProps {
  children: React.ReactNode;
  className?: string;
  borderRadius?: number;
  borderWidth?: number;
  animationDurationSeconds?: number;
  /** Applies featured plan card scale + stacking when true. */
  $elevated?: boolean;
  /** Scale transform when elevated; defaults to match $elevated. */
  $elevatedScale?: boolean;
}

export const AnimatedGradientBorder: React.FC<AnimatedGradientBorderProps> = ({
  children,
  className,
  borderRadius = 16,
  borderWidth = 1.35,
  animationDurationSeconds = 8.5,
  $elevated = false,
  $elevatedScale,
}) => (
  <div
    className={className ? `${styles.borderRoot} ${className}` : styles.borderRoot}
    data-elevated={$elevated ? 'true' : undefined}
    data-elevated-scale={
      $elevated && ($elevatedScale ?? $elevated) ? 'true' : undefined
    }
    style={
      {
        ['--pl-border-radius']: `${borderRadius}px`,
        ['--pl-border-width']: `${borderWidth}px`,
        ['--pl-duration']: `${animationDurationSeconds}s`,
      } as React.CSSProperties
    }
  >
    {children}
  </div>
);
